<wtf-dialogcontent [size]="'auto'" [dialogTitle]="dialogTitle" (closeModal)="close()" [action]="action">
    <!-- Content -->
    <div *ngIf="processing === false && finished === false">
        <form name="miembroCsvForm" [formGroup]="miembroCsvForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
            <!-- <mat-label>{{ "Delimitador" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select name="delimiter" formControlName="delimiter"
                    placeholder="{{ 'Seleccione un delimitador' | translate }}">
                    <mat-option *ngFor="let delimitador of delimiters" [value]="delimitador.value">{{
                        delimitador.delimiterValue }}</mat-option>
                </mat-select>
            </mat-form-field> -->

            <div fxLayoutAlign="center center" style="padding-top: 20px !important; margin-bottom: 20px">
                <div class="upload-container">
                    <div class="upload-button">
                        <label for="file" class="custom-file-upload">
                            {{ "Seleccionar archivo" | translate }}
                        </label>
                    </div>

                    <mat-label class="file-name">{{
                        "No se eligió el archivo" | translate
                        }}</mat-label>
                </div>

                <input #myInput type="file" id="file" (change)="handleFileInput($event.target.files)" />
                <input type="hidden" name="fileHidden" formControlName="fileInput" />
            </div>

            <button *ngIf="processing === false && finished === false" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="miembroCsvForm.invalid" aria-label="Enviar">
                <span class="material-icons-outlined mr-20"> save </span>
                {{ "Guardar" | translate }}
            </button>


        </form>
        <!-- Content -->

        <!-- Buttons -->
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" class="wait-indicator"
        *ngIf="processing === true && finished === false">
        <mat-spinner></mat-spinner>

        <h3>{{ "Procesando. Espere Por Favor" | translate }}</h3>
    </div>

    <div *ngIf="processing === false && finished === true">
        <!-- <ngx-charts-advanced-pie-chart [view]="view" [scheme]="widget6.scheme" [results]="results"
            [label]="widget6.label">
        </ngx-charts-advanced-pie-chart> -->
        <div class="d-flex justify-content-center align-items-center flex-column task-container">
            <h2 class="task-result">
                {{ "Archivo Subido" | translate }}
            </h2>
            <mat-icon class="task-done" aria-hidden="false" aria-label="Task Done" fontIcon="done"></mat-icon>

        </div>
        <button *ngIf="processing === false && finished === true" mat-raised-button (click)="close()"
            class="save-button mat-accent" aria-label="Cerrar">
            {{ "Cerrar" | translate }}
        </button>
    </div>

    <!-- Buttons -->
</wtf-dialogcontent>